import React, { useState } from 'react';
import AdminLayout from '../../../components/layout/AdminLayout';
import CourseTypeForm from '../../../components/forms/CourseTypeForm';
import { useCourseTypeById, useUpdateCourseType } from '../../../hooks/useCourseTypeApi';
import { useNavigate, useParams } from 'react-router-dom';
import { CourseTypeDTO } from '../../../services/apiClient';

const CourseTypeEdit: React.FC = () => {
  const { id } = useParams<{ id: string }>();
  const { data: entityData, isLoading } = useCourseTypeById(id!);
  const updateCourseType = useUpdateCourseType();
  const [isSubmitting, setIsSubmitting] = useState<boolean>(false);
  const navigate = useNavigate();

  const breadcrumbs = [
    { label: 'Admin', href: '#' },
    { label: 'Course Types', href: '/admin/coursetypes' },
    { label: 'Edit', href: '#' },
  ];

  const handleSubmit = async (data: any) => {
    try {
      setIsSubmitting(true);
      await updateCourseType.mutateAsync({ id: id!, data });
      navigate('/admin/coursetypes');
    } catch (error) {
      console.error('Error updating CourseType:', error);
    } finally {
      setIsSubmitting(false);
    }
  };

  return (
    <AdminLayout
      activeMenuItem="/admin/coursetypes"
      breadcrumbs={breadcrumbs}
      allowedRoles={['Admin']}
      requiredPermission="Settings.CourseType.Edit"
    >
      {entityData ? (
        <CourseTypeForm
          initialValues={entityData}
          onSubmit={handleSubmit}
          onCancel={() => navigate('/admin/coursetypes')}
          isLoading={isSubmitting}
        />
      ) : (
        <p>Loading...</p>
      )}
    </AdminLayout>
  );
};

export default CourseTypeEdit;
